import { createSlice } from "@reduxjs/toolkit";


const initialState: any = {
    customer: [],
    loading: false,
    error: null,
  };
const customerSlice = createSlice({
    name: "customer",
    initialState,
    reducers: {
        customerRequest(state) {
        state.loading = true;
        state.error = null;
      },
      customerSuccess(state, action) {
        state.loading = false;
        state.customer = action.payload;
      },
      customerAddSuccess(state, action) {
        state.loading = false;
        state.customer.push(action.payload);
      },
      customerEditSuccess(state, action) {
        state.loading = false;
        state.customer = state.customer.map((customer: { id: any; }) =>
          customer.id === action.payload.id ? action.payload : customer
        );
      },
      customerDeleteSuccess(state, action) {
        state.loading = false;
        state.customer = state.customer.filter((customer: { id: any; }) => customer.id !== action.payload);
      },
      customerError(state, action) {
        state.loading = false;
        state.error = action.payload;
      },
      getCustomerByIdRequest(state) {
        state.loading = true;
        state.error = null;
      },
      getCustomerByIdSuccess(state, action) {
        state.loading = false;
        state.user = action.payload;  
      },
      getCustomerByIdError(state, action) {
        state.loading = false;
        state.error = action.payload;
      },
       AssignChildIdRequest(state) {
            state.loading = true;
            state.error = null;
          },
          AssignChildIdError(state, action) {
            state.loading = false;
            state.error = action.payload;
          },
          AssignChildIdSuccess(state, action) {
            state.loading = false;
            state.user = action.payload;
          },
    },
    
  });

  export const {
      customerRequest,
      customerSuccess,
      customerAddSuccess,
      customerEditSuccess,
      customerDeleteSuccess,
      customerError,
      getCustomerByIdRequest,
      getCustomerByIdSuccess,
      getCustomerByIdError,
        AssignChildIdRequest,
  AssignChildIdError,
  AssignChildIdSuccess
  } = customerSlice.actions;

export default customerSlice.reducer;
  